import { LocalBusinessJsonLd } from 'next-seo';
import PropTypes from 'prop-types';
import React from 'react';

import { navigation } from '../../constants';
import getRestaurantPath from '../../utils/get-restaurant-path';

const RestaurantJsonLd = ({ restaurant }) => {
  if (!restaurant) {
    return null;
  }

  const nandosUrl = process.env.web.url;

  return (
    <LocalBusinessJsonLd
      type="Restaurant"
      name={restaurant.name}
      id={restaurant.id}
      url={`${nandosUrl}${getRestaurantPath(restaurant)}`}
      telephone={restaurant.phone}
      priceRange="$$"
      menu={`${nandosUrl}${navigation.MENU}`}
      servesCuisine="Afro-Portuguese"
      acceptsReservations="false"
      address={{
        '@type': 'PostalAddress',
        streetAddress: restaurant.address.address1,
        addressLocality: restaurant.address.suburb,
        addressRegion: restaurant.address.state,
        postalCode: restaurant.address.postcode,
        addressCountry: restaurant.address.country,
      }}
      geo={{
        '@type': 'GeoCoordinates',
        latitude: restaurant.latitude,
        longitude: restaurant.longitude,
      }}
      openingHours={restaurant.openingHours.map(openingHour => {
        return {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: openingHour.day,
          opens: openingHour.openingTime,
          closes: openingHour.closingTime,
        };
      })}
    />
  );
};

RestaurantJsonLd.propTypes = {
  restaurant: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    phone: PropTypes.string.isRequired,
    address: PropTypes.shape({
      address1: PropTypes.string.isRequired,
      suburb: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      postcode: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
    }).isRequired,
    openingHours: PropTypes.arrayOf(
      PropTypes.shape({
        day: PropTypes.string.isRequired,
        openingTime: PropTypes.string.isRequired,
        closingTime: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

export { RestaurantJsonLd };
